import { createGlobalStyle } from "styled-components";
import { color, typeStyle } from "@m/alchemy-theme";
import { cssReset } from "./css-reset";
// eslint-disable-next-line @m/magic/no-re-exports
export { default as whatInput } from "what-input";
const scope = ({ namespace }) => (namespace ? `:where(.${namespace})` : "");
const rootTagOrScope = (tag) => ({ namespace }) => namespace ? `${tag}:where(.${namespace}), ${tag} :where(.${namespace})` : tag;
export const GlobalStyles = createGlobalStyle `
  ${scope} {
    ${cssReset};
  }

  ${rootTagOrScope("html")} {
    box-sizing: border-box;  

    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }

  ${rootTagOrScope(`html[data-whatinput="touch"]`)},
  ${rootTagOrScope(`html[data-whatinput="mouse"]`)} {
    a,
    button,
    input,
    textarea,
    select,
    [tabindex] {
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      -webkit-tap-highlight-color: transparent;
      outline: none;
    }
  }

  ${rootTagOrScope("html")}, ${rootTagOrScope("body")} {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  ${rootTagOrScope("body")} {
    ${typeStyle("bodyL")};
    -webkit-text-size-adjust: 100%;
    color: ${color("typeBody")};
    line-height: 1;
  }

  /* Remove when DraggableList is removed */
  .alc-dnd ${scope} {
    &, * {
      cursor: move !important; /* fallback: no support or images disabled */
      cursor: -webkit-grabbing !important; /* Chrome 1-21, Safari 4+ */
      cursor: -moz-grabbing !important; /* Firefox 1.5-26 */
      cursor: grabbing !important; /* W3C standards syntax, should come least */
    }
  }

  ${(props) => props.globalCss}
`;
